var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "FormFieldsContainer",
    [
      _c(
        "v-flex",
        { attrs: { md2: "" } },
        [
          _c("v-checkbox", {
            attrs: {
              label: _vm.formFields.checkSoloResumen.label,
              disabled: _vm.accion === 3
            },
            on: { change: _vm.clickSoloResumen },
            model: {
              value: _vm.formFields.checkSoloResumen.value,
              callback: function($$v) {
                _vm.$set(_vm.formFields.checkSoloResumen, "value", $$v)
              },
              expression: "formFields.checkSoloResumen.value"
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }